export enum CoreType {
  HOOVER = 'hoover',
  STORAGE = 'storage',
  CANNABIS = 'cannabis',
  MULTIFAMILY = 'multifamily',
  MMP = 'mmp',
  HUMACH = 'humach',
  SPORTS_LAB = 'sports_lab',
  CAMPGROUND = 'campground',
  PHYSICIAN = 'physician',
  SMARTSCOOT = 'smartscoot'
}
